import { initialState } from './initial';
import { actionTypes } from './actions';

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LOGOUT:
      return { ...initialState };
    case actionTypes.SIGN_IN_SUCCESS:
      return { ...state, ...action.payload, isAuth: true };
    case actionTypes.GET_BALANCE:
      return { ...state, ...action.payload };
    case actionTypes.GET_NOTIFICATIONS:
      const hiddenNotifications = JSON.parse(localStorage.getItem('hiddenNotifications') || '[]');

      const filteredNotifications = action.payload?.filter(({ id }) => !hiddenNotifications.includes(id));
      return { ...state, notifications: filteredNotifications };
    case actionTypes.GET_CASHBACK_INFO:
      return { ...state, ...action.payload };
    default:
      return { ...state };
  }
};
